module.exports = __webpack_public_path__ + "images/home-and-contents.e29e96f5056032a1c3770b5adcf6e48f.svg";